import { db } from '@/components/Firebase_Conn'

// initial state
const state = {
  lastElement: {},
  searchResult: {}
}

// getters
const getters = {
  // eslint-disable-next-line no-undef
  loaded: state => state.loaded
}

// actions
const actions = {
  save({ commit, state, getters, actions }, payload) {
    //console.log(payload)
    var pointer = 'Utenti/' + this.state.loginStates.userDettails.uid
    var key = this.databaseOps.db.ref(pointer).push().key
    var paths = {}
    payload.id = key
    paths['clienti/' + key] = payload
    this.databaseOps.db.ref(pointer).update(paths, function (error) {
      if (error) {
        console.log('Errore operazione atomica ordini:', error)
      }
    })
    return key
    console.log('azione salva cliente')
  },
  update({ commit, state, getters, actions }, payload) {
    console.log('update')
    console.log(payload)
    var pointer = 'Utenti/' + this.state.loginStates.userDettails.uid
    //var key = this.databaseOps.db.ref(pointer).push().key
    var paths = {}
    paths['clienti/' + payload.id] = payload
    this.databaseOps.db.ref(pointer).update(paths, function (error) {
      if (error) {
        console.log('Errore operazione atomica clienti:', error)
      }
    })
    return payload.id
  },
  remove({ commit, state, getters, actions }, payload) {
    console.log(payload)
    var pointer = 'Utenti/' + this.state.loginStates.userDettails.uid + '/clienti'
    this.databaseOps.db.ref(pointer).child(payload).remove()
    console.log('azione cancella cliente')
  },
  search({ commit, state }, payload) {
    var pointer = 'Utenti/' + this.state.loginStates.userDettails.uid + '/' + payload.source
    return new Promise((resolve, reject) => {
      this.databaseOps.db.ref(pointer).orderByChild(payload.field).startAt(payload.value).endAt(payload.value + "\uf8ff").on('value', function (snapshot, prevChildKey) {
        resolve(snapshot.val())
      })
    })
  }
}

// mutations
const mutations = {
  setSearchResult(ojb) {
    state.searchResult = ojb
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
